<div [ngSwitch]="templateType">
  <div
    *ngSwitchCase="userTemplateTypes.nameOnly"
    class="name-only"
  >
    <div class="profile-image">
      <common-mojo-avatar
        [id]="candidate?.candidateImageId"
        [initials]="candidate?.initials"
        [backgroundSize]="avatarBackgroundSize"
      >
      </common-mojo-avatar>
    </div>
    <div class="user-name">
      <span>{{ user.firstName }} {{ user.lastName }}</span>
    </div>
  </div>

  <div
    *ngSwitchCase="userTemplateTypes.listItem"
    class="list-item"
  >
    <div class="row no-gutters">
      <common-mojo-avatar
        [id]="candidate?.candidateImageId"
        [initials]="candidate?.initials"
        [backgroundSize]="avatarBackgroundSize"
        [selectedPhotoShape]="avatarPhotoShape"
      >
      </common-mojo-avatar>
    </div>
    <div class="user-name">
      <span>{{ user.firstName }} {{ user.lastName }}</span>
    </div>
  </div>

  <div
    *ngSwitchCase="userTemplateTypes.material"
    class="list-item"
  >
    <div class="profile-image">
      <common-mojo-avatar
        [id]="candidate?.candidateImageId"
        [initials]="candidate?.initials"
      >
      </common-mojo-avatar>
    </div>
    <div class="user-name">
      <span>{{ user.firstName }} {{ user.lastName }}</span>
    </div>
  </div>
</div>
